import {Component, OnDestroy, OnInit, SecurityContext} from '@angular/core';
import {Filter} from '../../models/warranties/filter.model';
import {HttpService} from '../../services/http.service';
import {WarrantyList} from '../../models/warranties/warranty-list.model';
import {ContractTypeDistinctModel} from '../../models/warranties/contract-type-distinct.model';
import {WarrantyListItem} from '../../models/warranties/warranty-list-item.model';
import {Warranty} from '../../models/warranties/warranty.model';
import {AuthService} from '../../auth/auth.service';
import {Market} from '../../models/dealers/market.enum';
import {FilterService} from './filter-service';
import {I18nPipe} from '../../services/i18n.pipe';
import {DomSanitizer} from '@angular/platform-browser';
import {SweetUtil} from '../commons/sweet/sweet-util-service';
import {MessageMenuComponent} from '../messages/message-menu/message-menu.component';
import {DecimalUtil} from '../commons/util/decimal-util';

@Component({
  selector: 'app-warranty-list',
  templateUrl: './warranty-list.component.html',
  styleUrls: ['./warranty-list.component.scss']
})

export class WarrantyListComponent implements OnInit, OnDestroy {

  constructor(private http: HttpService, private authService: AuthService, private filterService: FilterService,
              private i18nPipe: I18nPipe, private sweetUtil: SweetUtil, private sanitizer: DomSanitizer,
              private messageMenu: MessageMenuComponent) {
  }
  warrantyList: WarrantyList = new WarrantyList();
  dataList: any[] = [];
  contractTypes: ContractTypeDistinctModel[] = [];
  dashCounts: any[] = [];
  warranty: Warranty = new Warranty();
  dealerName: any[] = [];
  showAttachments = false;
  showExtendedWarranty = false;
  showNinetyDaysPlusInProgressUI = false;

  ngOnInit(): void {
    this.showAttachments = this.authService.market() === Market.BE;
    this.showExtendedWarranty = this.authService.market() === Market.BE;
    this.fetchContractTypes();
    this.refreshNinetyPlusInProgressList();
    this.fetchDashboardCounts();
    this.getDealers();
    this.messageMenu.displayMessages();
  }

  alertNinetyPlusInProgress() {
    if (sessionStorage.getItem('firstNinetyDaysInProgressAlert') === null) {
      let msg = this.i18nPipe.transform('', 'ninety-day-plus-in-progress-alert-a');
      msg = msg != null && msg !== '' ? `${msg} ` : '';
      msg += `${this.warrantyList.rowCount} ${this.i18nPipe.transform('', 'ninety-day-plus-in-progress-alert-b')}`;
      this.sweetUtil.showInfoTitleTranslated(msg).then();
      sessionStorage.setItem('firstNinetyDaysInProgressAlert', 'true');
    }
  }

  amount(warrantListItem: WarrantyListItem): string {
    const amount = (warrantListItem.amountToBeCharged || warrantListItem.amountToBeCharged === 0)
      ? warrantListItem.amountToBeCharged : warrantListItem.contractRate;
    return (amount || amount === 0) ? `EUR ${DecimalUtil.enforceDecimals(amount)}` : 'EUR 0.00';
  }

  getDealers() {
    if (this.authService.isAdmin()) {
      this.http.fetchDealers().subscribe((res) => {
        res?.sort((a, b) => (a.dealerName > b.dealerName) ? 1 : -1).forEach((d) => {
          this.dealerName.push(d.dealerName);
        });
      });
    }
  }

  fetchContractTypes() {
    this.http.fetchDistinctContractTypes().subscribe((res) => {
      this.contractTypes = res;
    });
  }

  exportAsXLSX() {
    this.getFilter().pageSize = 20000;
    if (!this.showNinetyDaysPlusInProgressUI) {
      this.http.downloadReport(this.getFilter());
    } else {
      this.getFilter().status = 'In Progress';
      this.getFilter().dealerNumber = sessionStorage.getItem('dealer');
      this.getFilter().dealerName = sessionStorage.getItem('company');
      this.http.downloadInProgressNinetyDaysPlusReport(this.getFilter());
      this.getFilter().status = null;
      this.getFilter().dealerNumber = null;
      this.getFilter().dealerName = null;
    }
  }

  printCertificateFR($event, warrantyNumber: string) {
    this.printCertificate($event, warrantyNumber, 'FR');
    $event.stopPropagation();
  }

  printCertificateNL($event, warrantyNumber: string) {
    this.printCertificate($event, warrantyNumber, 'NL');
    $event.stopPropagation();
  }

  printCertificate($event, warrantyNumber: string, lang: string) {
    this.http.downloadCertificate(warrantyNumber, warrantyNumber + '_Certificate.pdf', lang);
  }

  refreshList() {
      this.http.fetchWarranties(this.getFilter()).subscribe((res: WarrantyList) => {
      this.warrantyList = Object.assign(new WarrantyList(), res);
    });
  }

  refreshNinetyPlusInProgressList() {
    if (this.authService.isUser()) {
      if (sessionStorage.getItem('switchTabs') === null) {
        this.getFilter().status = 'In Progress';
        this.getFilter().dealerNumber = sessionStorage.getItem('dealer');
        this.getFilter().dealerName = sessionStorage.getItem('company');
        this.http.fetchWarrantiesNinetyDaysPlusInProgress(this.getFilter()).subscribe((res: WarrantyList) => {
          this.warrantyList = Object.assign(new WarrantyList(), res);
          if (this.warrantyList.pageCount > 0) {
            this.showNinetyDaysPlusInProgressUI = true;
            if (this.getFilter().page === 0) {
              this.alertNinetyPlusInProgress();
            }
          } else if (!this.showNinetyDaysPlusInProgressUI) {
            this.refreshList();
          }
        });
        this.getFilter().status = null;
        this.getFilter().dealerNumber = null;
        this.getFilter().dealerName = null;
      } else {
        this.refreshList();
      }
    } else {
      this.refreshList();
    }
  }

  fetchDashboardCounts() {
    this.http.fetchDashCounts().subscribe((res: any) => {
      this.dashCounts = res;
    });
  }

  getCountForType(status: string): number {
    if (status === 'all') {
      let allCount = 0;
      this.dashCounts.forEach(dashCount => allCount += dashCount.count);
      return allCount;
    }
    const d = this.dashCounts.find(dash => dash.status === status);
    if (d) {
      return d.count;
    } else {
      return 0;
    }
  }

  filterByStatus(status: string) {
    this.getFilter().status = status;
    this.getNinetyDaysPlusInProgressOrAllWarranties();
  }

  orderBy(field: string) {
    if (this.getFilter().orderBy === field) {
      if (this.getFilter().order === 'ASC') {
        this.getFilter().order = 'DESC';
      } else {
        this.getFilter().order = 'ASC';
      }
    }
    this.getFilter().orderBy = field;
    this.getNinetyDaysPlusInProgressOrAllWarranties();
  }

  showDirectionImage(): string {
    if (this.getFilter().order === 'ASC') {
      return 'assets/images/icon-sort-up.png';
    } else {
      return 'assets/images/icon-sort-down.png';
    }
  }

  clearFilter() {
    this.filterService.resetDashboardFilter();
    this.refreshList();
    this.showNinetyDaysPlusInProgressUI = false;
  }

  changePage(count: number) {
    this.getFilter().page += count;
    this.getNinetyDaysPlusInProgressOrAllWarranties();
  }

  downloadCertificate($event, warrantyNumber: string) {
    $event.stopPropagation();
    this.http.downloadCertificate(warrantyNumber, warrantyNumber + '_Certificate.pdf');
  }

  getClass(status: string): string {
    if (status.indexOf(' ') > -1) {
      status = status.replace(' ', '-');
    }
    return status.toLowerCase();
  }

  showFile(warrantyListItem: WarrantyListItem) {
    return (warrantyListItem.status === 'Active' || warrantyListItem.status === 'Accepted') && (
      warrantyListItem.contractType === '' || warrantyListItem.contractType === 'MINI NEXT' ||
      warrantyListItem.contractType === 'Motorrad Premium Selection' ||
      warrantyListItem.contractType === 'BMW Premium Selection'
    );
  }

  getFilter(): Filter {
    return this.filterService.getDashboardFilter();
  }

  getNinetyDaysPlusInProgressOrAllWarranties() {
    if (this.showNinetyDaysPlusInProgressUI) {
      this.refreshNinetyPlusInProgressList();
    } else {
      this.refreshList();
    }
  }

  inProgressFilterExecution() {
    if (!this.showNinetyDaysPlusInProgressUI) {
      this.refreshList();
    }
  }

  sanitizeAndStyleData(value: any, domElementName: string) {
    const ele = document.getElementById(domElementName);
    ele.innerHTML = `${this.sanitizer.sanitize(SecurityContext.HTML, value)}`;
    const span = ele.querySelectorAll('span');
    span[0].style.padding = '5px';
    span[0].style.paddingLeft = '10px';
    span[0].style.paddingRight = '10px';
    span[0].style.textAlign = 'center';
    span[0].style.backgroundColor = '#92a2bd';
    span[0].style.color = '#ffffff';
  }

  isAdmin(): boolean {
    return this.authService.isAdmin();
  }

  isUser(): boolean {
    return this.authService.isUser();
  }

  isReadOnlyUser(): boolean {
    return this.authService.isReadOnlyUser();
  }

  ngOnDestroy(): void {
    sessionStorage.setItem('switchTabs', 'true');
  }

  enforceTrailingZeros(val: any){
    return DecimalUtil.enforceDecimals(val);
  }
}
